import { actions } from '@/store/module/subscription/action/actions.js';
import { mutations } from '@/store/module/subscription/mutation/mutations.js';

export const subscription = {
	namespaced: true,

	state: () => ({
		isSubscribed: false,
		products: [],
		subscription: {}
	}),

	actions,
	mutations
};
